import DescriptionIcon from '@mui/icons-material/Description';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import useShipmentLabelDetailsDialog from 'hooks/dialogs/useShipmentLabelDialog';
import { ShipmentsData } from 'models/Shipments';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { RowItems } from '../../models/TableProps';

export const ShipmentsTableRow: React.FC<RowItems<ShipmentsData>> = (props) => {
    const { row, index } = props;
    const { t } = useTranslation('invoices');
    const labelId = `enhanced-table-checkbox-${index}`;

    const shipmentLabelDetailsDialog = useShipmentLabelDetailsDialog();

    return (
        <TableRow hover>
            <TableCell component="th" id={labelId} scope="row">
                {row.number}
            </TableCell>
            <TableCell align="right">{row.customerName}</TableCell>
            <TableCell align="right">{row.invoiceDate}</TableCell>
            <TableCell align="right">{row.orderNumber}</TableCell>
            <TableCell align="right">
                <DescriptionIcon
                    onClick={() =>
                        shipmentLabelDetailsDialog.showDialog(true, row)
                    }
                    sx={{ cursor: 'pointer' }}
                />
            </TableCell>
        </TableRow>
    );
};
